const CRM_KEYS = {
	QUERY: {
		SALES_LEAD: "getSalesLeads",
		COUNTRY: "getCountries",
		VEHICLE_OPTIONS: "selectedVehicleOptions",
		DISPOSITION: "getDispositions",
		CUSTOMER: "getCustomers",
		REPUTATION_REVIEWS_DATA_ROW: "getSocialMediaReviewSummary",
		INVENTORY_DESIRED_VEHICLES: "getInventoryDesiredVehicles",
	},
	MUTATION: {
		CREATE_SALE_LEAD: "createSalesLeadMutation",
	},
	SUBSCRIPTION: {
		SALES_LEAD: "salesLead",
		DISPOSITION: "disposition",
		CUSTOMER: "customer",
		SOCIAL_MEDIA_REVIEW: "socialMediaReviews",
	},
};

export { CRM_KEYS };
